const activityNoteStyle = {
  noteContainer: {
    marginLeft: "0px",
    padding: "1rem",
    backgroundColor: "background.note",
    overflowWrap: "break-word",
  },
  note: {
    overflowWrap: "anywhere",
    overflow: "hidden",
    minHeight: "2rem",
  },
  collapsedNote: {
    height: "2rem",
  },
  icon: {
    color: "text.primary",
    display: "block",
    margin: "0 0 0 auto",
  },
};

export default activityNoteStyle;
